<template>
  <div style="margin: 12px 40px 12px 40px;">
<!--    <div v-if="idx > -1" style="text-align: right; margin: -24px 0 8px"><el-button type="text" @click="cancelBook">取消预约</el-button></div>-->
    <el-form ref="formRef" :model="bookForm" label-width="90px" label-position="left">
      <el-form-item label="宠物主人："  v-if="idx == -1">
        <el-button @click="editUserDialog">创建新客</el-button>
        <el-button @click="selectUser">选择老客</el-button>
      </el-form-item>
      <el-descriptions border :column="2" size="small" v-if="userInfo && JSON.stringify(userInfo) != '{}'" style=" margin-bottom: 24px; width: 100%">
        <template #title v-if="idx > -1">
          <span style="font-size: 14px; font-weight: normal">主人信息</span>
        </template>
        <template #extra v-if="idx > -1 && bookForm.editState == 0 && editable">
          <el-link type="primary" @click="cancelBook">取消预约</el-link>
        </template>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人">
          <div style="display: flex;">
            <span style="margin-right: 16px; cursor: pointer; color: #409eff" @click="userInfoDialog(userInfo.id)">{{ userInfo.name }}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="账户">
          <div style="display: flex;">
            <span v-if="userInfo.userWallet">
               余额: <span style="color: #409eff; cursor: pointer;" @click="getPayDeductionList(userInfo, -2)">{{userInfo.userWallet.balanceSumAll}}</span> / 充值: <span style="color: #409eff; cursor: pointer;" @click="getPayDeductionList(userInfo, 1)">{{userInfo.userWallet.paySum}}</span>
            </span>
          </div>
        </el-descriptions-item>
<!--                    <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" :span="2">{{ userInfo.sex == 1?'男':userInfo.sex == 2?'女':'未知' }}</el-descriptions-item>-->
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机">{{ userInfo.phone }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店">{{ userInfo.shopName}}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="描述" :span="2">
          <p v-if="userInfo.userPerfect" style="line-height: 1.3; margin: 4px 0;">{{userInfo.userPerfect.userDesc}}</p>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="图片" :span="2">
          <el-space wrap>
            <div class="img-box" v-for="(item, index) in userInfo.userImgList" :key="item.id"  @click="showImg(index, userInfo.userImgList)" style="cursor: pointer;">
              <el-image style="width: 40px; height: 40px;" fit="cover" :src="item.img" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </el-space>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="备注" :span="2">
          <!--            <UserRemark :userRemarkList="bookForm.userRemarkList" />-->
          <div style="margin: 4px 0; line-height: 1.3">
            <p v-for="(item, index) of userInfo.userRemarkList" :key="index">
            <span style="margin-right: 12px;">{{item.createTime}}</span>
            <span style="margin-right: 8px;" v-high-light="{value: item.content}">{{item.content}}</span>
            </p>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions title="总余额" border :column="2" size="small" style="margin-bottom: 24px;" v-if="userInfo && JSON.stringify(userInfo) != '{}'">
        <template #title>
          <p>总余额：<span v-if="userInfo.userWallet" style="color: #3a8ee6">{{ userInfo.userWallet.balanceSumAll}}<span class="giveFont" v-if="userInfo.userWallet.balanceSumAll">（{{userInfo.userWallet.balanceSum}} + {{userInfo.userWallet.balanceSumGive}}）</span></span></p>
        </template>
        <template #extra>
          <el-button type="danger" size="small" @click="getPayDeductionList(userInfo)">充值</el-button>
        </template>
        <div v-if="userInfo.userWallet">
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userInfo.userWallet.balanceSumOne}}<span class="giveFont" v-if="userInfo.userWallet.balanceSumOne">（{{ userInfo.userWallet.balanceOne}} + {{userInfo.userWallet.balanceOneGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userInfo.userWallet.balanceSumTwo}}<span class="giveFont"  v-if="userInfo.userWallet.balanceSumTwo">（{{ userInfo.userWallet.balanceTwo}} + {{userInfo.userWallet.balanceTwoGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userInfo.userWallet.balanceSumThree}}<span class="giveFont"  v-if="userInfo.userWallet.balanceSumThree">（{{ userInfo.userWallet.balanceThree}} + {{userInfo.userWallet.balanceThreeGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userInfo.userWallet.balanceSumFour}}<span class="giveFont"  v-if="userInfo.userWallet.balanceSumFour">（{{ userInfo.userWallet.balanceFour}} + {{userInfo.userWallet.balanceFourGive}}）</span></el-descriptions-item>
        </div>

      </el-descriptions>

      <el-descriptions v-if="bookForm.editState == 1 || !editable" border :column="2" size="small" style=" margin-bottom: 16px; width: 100%">
        <template #title>
          <span style="font-size: 14px; font-weight: normal">预约信息</span>
        </template>
        <template #extra v-if="from != 'give'">
          <span v-if="!editable" style="font-size: 12px; color: red;">*当前角色没有该门店的编辑权限</span>
          <span v-if="bookForm.editState == 1" style="font-size: 12px; color: red;">*三天后无法修改</span>
        </template>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="预约宠物" :span="2">
          <el-checkbox-group v-if="userInfo" v-model="checkList" size="small" disabled>
            <div v-for="item of petList" :key="item.id"><el-checkbox :label="item.id" >{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</el-checkbox></div>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="预约时间" :span="2">{{ preDay }} {{ preTime }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="预约备注" :span="2">{{ bookForm.remark}}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="消费项目" :span="2">
          <div><span v-if="bookForm.projectAll">{{ bookForm.projectAll.contentTotal }}</span></div>
          <div v-if="bookForm.projectAll" style="width: 100%">
            <el-table
                ref="multipleTableRef"
                :data="bookForm.projectAll.projectOneList"
                style="width: 100%; "
                size="small"
                border
            >
              <el-table-column property="name" label="消费项目" width="200">
                <template #default="scope">
                  <span style="white-space: nowrap; text-overflow: ellipsis;">{{scope.row.name}}<span v-if="scope.row.isGive == 1">（赠送）</span></span>
                </template>
              </el-table-column>
              <el-table-column property="amount" label="张数/数量" >
                <template #default="scope">
                  <span v-if="(scope.row.projectType == 1 && scope.row.projectServiceType != 3) || (scope.row.projectId == 0 && scope.row.commodityId == 0 && scope.row.projectServiceType == 3)">1</span>
                  <span v-else>{{scope.row.amount}}</span>
                </template>
              </el-table-column>
              <el-table-column property="price" label="金额" />
              <el-table-column property="operateAdminName" label="负责人" />
              <el-table-column property="visitDay" label="回访天数" >
                <template #default="scope">
                  {{scope.row.visitDay == -1?'无需回访':scope.row.visitDay == 0?'立即回访':scope.row.visitDay}}
                </template>
              </el-table-column>
            </el-table>
          </div>

        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="支付记录" :span="2"><span v-if="bookForm.paymentDetail">{{ bookForm.paymentDetail.content}}</span></el-descriptions-item>
      </el-descriptions>
      <div v-else>
        <el-form-item label="预约宠物：" v-if="userInfo && JSON.stringify(userInfo) != '{}'">
          <div style="width: 100%">
            <el-checkbox-group v-model="checkList" style="width: 100%">
              <div v-for="(item,index) of petList" :key="item.id" class="pet-list-item">
                <div>
                  <el-checkbox :label="item.id">
                    <span>{{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}</span>
                  </el-checkbox>
                  <p v-if="item.exemptionDesc" style="color: red; font-size: 12px; line-height: 1; margin-top: -8px;margin-bottom: 12px;">*{{item.exemptionDesc}}</p>
                  <div style="font-size: 12px;margin-bottom: 8px;" v-if="checkList.indexOf(item.id) > -1">
                    <span>体重：</span>
                    <el-input type="number" v-model="item.weight" style="width: 16em" placeholder="请输入本次体重">
                      <template #suffix>kg</template>
                    </el-input>
                    <p style="color: red">* 请如实填写，此信息客户可见</p>
                  </div>
                </div>

                <div style="display: flex;" >
                  <el-button  v-if="checkList.indexOf(item.id) > -1" type="success" size="small" @click="checkPetWeightList(item)">查看体重</el-button>
<!--                  <el-button v-if="bookForm.id && checkList.indexOf(item.id) > -1 && appletOpen" type="success" size="small" @click="editPetImg(item)">查看图片</el-button>-->
                  <el-button type="primary" size="small" @click="updatePet(index, item)">编辑</el-button>
                </div>
              </div>
            </el-checkbox-group>
            <div :style="{marginTop: petList.length > 0?'8px':''}">
              <el-button  @click="addPet(-1)">+ 添加宠物</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="预约时间：">
          <div style="display: flex">
            <el-date-picker
                v-model="preDay"
                type="date"
                placeholder="选择日期"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                style="width: 50%; margin-right: 0.5em"
            />
            <el-time-select
                v-model="preTime"
                style="width: 50%;"
                placeholder="选择时间"
                :start="startTime"
                step="00:05"
                :end="endTime"
            />
          </div>
        </el-form-item>
        <el-form-item label="预约备注：">
          <el-input type="textarea" :rows="3" v-model="remark" placeholder="请输入备注内容" style="width: 100%" />
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            <el-checkbox v-model="remarkChecked" :checked="remarkChecked">该备注归为充值备注</el-checkbox>
            <el-button type="text" @click="openRemarkDialog">历史充值备注</el-button>
          </div>

        </el-form-item>
        <el-form-item label="消费项目：" v-if="idx > -1">
          <div v-if="bookForm.projectAll" style="width: 100%; display: flex; justify-content: space-between;">
            <p>
              <span v-if="bookForm.projectAll">{{ bookForm.projectAll.contentTotal }}</span>
              <span v-else style="opacity: 0.4">项目已清除</span>
            </p>
            <el-button type="text"  @click="addProject(1)">编辑</el-button>
          </div>
          <el-button v-else @click="addProject(-1)">+ 添加</el-button>
          <div v-if="bookForm.projectAll" style="width: 100%">
            <el-table
                ref="multipleTableRef"
                :data="bookForm.projectAll.projectOneList"
                style="width: 100%; "
                size="small"
                border
            >
              <el-table-column property="name" label="消费项目" width="200">
                <template #default="scope">
                  <span style="white-space: nowrap; text-overflow: ellipsis;">{{scope.row.name}}<span v-if="scope.row.isGive == 1">（赠送）</span></span>
                </template>
              </el-table-column>
              <el-table-column property="petName" label="服务宠物" />
              <el-table-column property="amount" label="张数/数量" >
                <template #default="scope">
                  <span v-if="(scope.row.projectType == 1 && scope.row.projectServiceType != 3) || (scope.row.projectId == 0 && scope.row.commodityId == 0 && scope.row.projectServiceType == 3)">1</span>
                  <span v-else>{{scope.row.amount}}</span>
                </template>
              </el-table-column>
              <el-table-column property="originalPrice" label="原价" />
              <el-table-column property="discountNUm" label="会员优惠" >
                <template #default="scope">
                  <p v-if="scope.row.discountNUm > 0" style="color: red">-{{scope.row.discountNUm}}</p>
                </template>
              </el-table-column>
              <el-table-column property="extraNUm" label="额外优惠" >
                <template #default="scope">
                  <p v-if="scope.row.extraNUm > 0" style="color: red">-{{scope.row.extraNUm}}</p>
                </template>
              </el-table-column>
              <el-table-column property="firstDiscountNum" label="初步优惠后合计"  width="110" />
              <el-table-column property="giveNum" label="赠送金额" v-if="bookForm.paymentDetail" >
                <template #default="scope">
                  <p v-if="scope.row.giveNum > 0" style="color: red">-{{scope.row.giveNum}}</p>
                </template>
              </el-table-column>
              <el-table-column property="afterDiscountNum" label="总优惠后合计" width="110" v-if="bookForm.paymentDetail" />
              <el-table-column property="operateAdminName" label="负责人" />
              <el-table-column property="visitDay" label="回访天数" >
                <template #default="scope">
                  {{scope.row.visitDay == -1?'无需回访':scope.row.visitDay == 0?'立即回访':scope.row.visitDay}}
                </template>
              </el-table-column>
            </el-table>
          </div>

        </el-form-item>
        <el-form-item label="支付记录：" v-if="idx > -1">
<!--          <div v-if="bookForm.paymentDetailPageResp" style="width: 100%; display: flex; justify-content: space-between;">-->
<!--            <p>{{ bookForm.paymentDetailPageResp.content }}</p>-->
<!--            <el-button type="text" @click="addPayment(1)">编辑</el-button>-->
<!--          </div>-->
          <div v-if="bookForm.paymentDetail" style="width: 100%; display: flex; justify-content: space-between;">
            <p>
              <span v-if="bookForm.paymentDetail">{{ bookForm.paymentDetail.content }}</span>
              <span v-else style="opacity: 0.4">项目已清除</span>
            </p>
            <el-button type="text"  @click="addPayment(1)">编辑</el-button>
          </div>
          <el-button v-else @click="addPayment(-1)">+ 添加</el-button>
        </el-form-item>
      </div>
      <el-form-item label="零食状态："  v-if="idx > -1">
        <el-radio-group v-model="snackState">
          <el-radio :label="1">已赠送</el-radio>
          <el-radio :label="2">未赠送</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预约状态：">
        <div v-if="idx > -1">
          <el-radio-group v-model="state" :disabled="bookForm.editState == 1 || !editable" @change="stateChange">
            <el-radio :disabled="confirmState == 2 && !operateState" :label="-1" v-if="appletOpen">待确认</el-radio>
            <el-radio :disabled="confirmState == 1 && !operateState" :label="0">待到店</el-radio>
            <el-radio :disabled="confirmState == 1 && !operateState" :label="1">服务中</el-radio>
            <el-radio :disabled="confirmState == 1 && !operateState" :label="2">已离店</el-radio>
          </el-radio-group>
          <p class="pre-tip" v-if="confirmToast && !operateState && appletOpen"><span style="color: red">* </span>{{ confirmToast }}</p>
        </div>
        <div v-else>
          <el-radio-group v-model="state" :disabled="bookForm.editState == 1 || !editable" @change="stateChange">
            <el-radio :disabled="confirmState == 2" :label="-1" v-if="appletOpen">待确认</el-radio>
            <el-radio :disabled="confirmState == 1" :label="0">待到店</el-radio>
            <el-radio :disabled="confirmState == 1" :label="1">服务中</el-radio>
            <el-radio :disabled="confirmState == 1" :label="2">已离店</el-radio>
          </el-radio-group>
          <p class="pre-tip" v-if="confirmToast && appletOpen"><span style="color: red">* </span>{{ confirmToast }}</p>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;" v-if="bookForm.editState != 1 && editable">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, getFormData, postJson} from "@/api/api"
import {addOrUpdatePreBook, getPet, cancelPreBook, getUserInfo} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import Drawer from "@/assets/js/drawer"
import AddOrUpdatePet from "@/views/user/components/AddOrUpdatePet";
import UserListDialog from "@/views/preBook/components/UserListDialog";
import UserRemark from "@/components/Remark/UserRemark";
import UserInfo from "@/components/User/userInfo"
import UserDialog from "@/views/user/components/UserDialog";
import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
import EditProjectDialog from "@/views/user/components/project/EditProjectDialog";
import payListDialog from "@/views/user/components/payListDialog";
import DeductionListDialog from "@/views/user/components/DeductionListDialog";
import {add, mul, Number_SubAll} from "@/assets/shared/util";
import ImgViewer from "@/assets/js/imageViewer";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import userInfoDialog from "@/components/User/userInfoDialog";
import PetImgList from "@/views/preBook/components/PetImgList";
import PayDeductionListDialog from "@/views/user/components/PayDeductionListDialog";
import PetWeightDialog from "@/views/user/components/PetWeightDialog";

export default {
  name: "ProBookDialog",
  components: { UserRemark, UserInfo },
  props: {
    value: Object
  },
  data() {
    return {
      from: this.value.from,
      appletOpen: this.value.appletOpen,
      bookForm: this.value.bookForm,
      editable: this.value.editable,//用户编辑权限
      userInfo: this.value.bookForm.userInfo,
      weekDayName: this.value.weekDayName,
      dateTime: this.value.dateTime,
      idx: this.value.ids,
      shopId: this.value.shopId,
      preTime: this.value.bookForm.preTime?this.value.bookForm.preTime:'16:00',
      startTime: this.value.startTime,
      endTime: this.value.endTime,
      // endTime: '20:30',
      preDay: this.value.bookForm.preDay?this.value.bookForm.preDay:'',
      snackState: this.value.bookForm.snackState?this.value.bookForm.snackState:0,
      remark: this.value.bookForm.remark,
      remarkChecked: this.value.bookForm.remarkChargeState?true:false,
      // checkList: this.value.ids > -1?this.value.bookForm.petIdList:[],
      checkList: [],
      petList: [],
      state: 0,

      confirmState: 0,
      confirmToast: '',

      operateState: (JSON.parse(sessionStorage.getItem('operateState')) & 16) == 16
    }
  },
  methods: {

    stateChange(val) {

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i<list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.userInfo || JSON.stringify(this.userInfo) == '{}') {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先添加客户信息',
          type: 'warning'
        });
        return false
      }
      if(this.checkList.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先勾选需要预约的宠物',
          type: 'warning'
        });
        return false
      }

      if(!this.preTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请添加预约时间',
          type: 'warning'
        });
        return false
      }
      if(!this.bookForm.paymentDetail && this.idx > -1 && this.state == 2) {
        if(this.bookForm.projectAll) {
          let priceAll = 0
          this.bookForm.projectAll.projectOneList.map(item => {
            priceAll += item.price
          })
          if(priceAll > 0) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: '请添加支付记录',
              type: 'warning'
            });
            return false
          }
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '请添加支付记录',
            type: 'warning'
          });
          return false
        }
      }


      let petArr = []
      this.checkList.map(item => {
        let obj = {}
        for(let i=0; i<this.petList.length; i++) {
          if(item == this.petList[i].id) {
            obj.id = this.petList[i].id
            obj.weight = this.petList[i].weight
          }
        }
        petArr.push(obj)
      })
      if(this.state == 1 || this.state == 2) {
        if(petArr.some(item => !item.weight)) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '请输入预约宠物的体重',
            type: 'warning'
          });
          return false
        }
      }

      if(!this.snackState && this.state == 2) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择是否赠送零食',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.bookForm.id:0;
      param['userId'] = this.userInfo.id;
      param['preDay'] = this.preDay;
      param['preTime'] = this.preTime;
      param['remark'] = this.remark?this.remark:'';
      param['remarkChargeState'] = this.remarkChecked?1:0;
      param['shopId'] = this.shopId;
      // param['petIdArr'] = this.checkList;

      param['petList'] = petArr;
      param['state'] = this.state;
      param['snackState'] = this.snackState;

      postJson(addOrUpdatePreBook, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


    editUserDialog() {
      let _title = '创建新客';
      let userForm = {}
      Dialog.open({
        title: _title,
        component: UserDialog,
        data: {
          userForm: userForm,
          ids: -2,
          width: '600px',
        },
        confirm: (result) => {
          this.getUserInfo(result, true)
        }
      })
    },

    getUserInfo(id, resetWeight) {
      let param = {};
      param['id'] = id;
      getFormData(getUserInfo, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.userInfo = data.data
          this.userInfo.userWallet.paySum = add([this.userInfo.userWallet.paySumOne, this.userInfo.userWallet.paySumTwo, this.userInfo.userWallet.paySumThree, this.userInfo.userWallet.paySumFour, this.userInfo.userWallet.paySumOneGive, this.userInfo.userWallet.paySumTwoGive, this.userInfo.userWallet.paySumThreeGive, this.userInfo.userWallet.paySumFourGive])
          // this.userInfo.userWallet.balanceSum = add([this.userInfo.userWallet.balanceOne, this.userInfo.userWallet.balanceTwo, this.userInfo.userWallet.balanceThree, this.userInfo.userWallet.balanceFour, this.userInfo.userWallet.balanceOneGive, this.userInfo.userWallet.balanceTwoGive, this.userInfo.userWallet.balanceThreeGive, this.userInfo.userWallet.balanceFourGive])
          this.userInfo.userWallet.balanceSum = add([this.userInfo.userWallet.balanceOne, this.userInfo.userWallet.balanceTwo, this.userInfo.userWallet.balanceThree, this.userInfo.userWallet.balanceFour])
          this.userInfo.userWallet.balanceSumGive = add([this.userInfo.userWallet.balanceOneGive, this.userInfo.userWallet.balanceTwoGive, this.userInfo.userWallet.balanceThreeGive, this.userInfo.userWallet.balanceFourGive])
          this.userInfo.userWallet.balanceSumAll = add([this.userInfo.userWallet.balanceSum, this.userInfo.userWallet.balanceSumGive])
          this.userInfo.userWallet.balanceSumOne = add([this.userInfo.userWallet.balanceOne, this.userInfo.userWallet.balanceOneGive])
          this.userInfo.userWallet.balanceSumTwo = add([this.userInfo.userWallet.balanceTwo, this.userInfo.userWallet.balanceTwoGive])
          this.userInfo.userWallet.balanceSumThree = add([this.userInfo.userWallet.balanceThree, this.userInfo.userWallet.balanceThreeGive])
          this.userInfo.userWallet.balanceSumFour = add([this.userInfo.userWallet.balanceFour, this.userInfo.userWallet.balanceFourGive])
          if(this.appletOpen) {
            this.state = -1
            this.confirmState = 1
            this.confirmToast = '该预约单需要客户确认预约后才能修改预约状态'
            let dateN = new Date(this.getTodayDate() + ' ' + '00:00:00')
            let dateP = new Date(this.preDay + ' ' + this.preTime + ':00')
            if(dateP < dateN) {
              this.state = 0
              this.confirmState = 2
              this.confirmToast = '该预约单的预约日期小于当天，无需客户确认预约'
            }
            if(this.userInfo.type == 1) {
              this.state = 0
              this.confirmState = 2
              this.confirmToast = '门店散客无需确认预约'
            }
          }

          if(resetWeight) {
            this.userInfo.petList.map(pet => {
              pet.weight = ''
            })
          }

          this.petList = this.userInfo.petList

        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(()=> {
      })
    },

    cancelBook() {
      this.$confirm('是否确定取消此预约单？？').then(() => {
        let param = {};
        param['id'] = this.bookForm.id;
        postFormData(cancelPreBook, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm')
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        }).catch(()=> {
        })
      })
    },

    selectUser() {
      Drawer.open({
        title: '客户列表',
        component: UserListDialog,
        data: {
          shopId: this.shopId,
          width: 600
        },
        confirm: (result) => {
          this.getUserInfo(result.id, true)
        }
      })
    },

    addPayment(idx) {
      // getFormData(getUserInfo, {id: this.userInfo.id}).then((data)=>{
      //   this.userInfo.userWallet = data.data.userWallet
      //
      // })
      if(this.bookForm.state == -1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前预约单未确认，无法操作',
          type: 'warning'
        });
        return false
      }
      let payDetailForm = {};
      let _title = '';
      if(idx > -1) {
        _title = '编辑支付记录'
        payDetailForm = this.bookForm.paymentDetail
      } else {
        _title = '添加支付记录'
      }
      // if(idx == -1) {
      //   _title = '添加支付记录'
      //   payDetailForm.shopId = this.bookForm.preShopId
      // }else {
      //   _title = '编辑支付记录'
      //   payDetailForm = this.bookForm.paymentDetailPageResp
      //   payDetailForm.shopName = this.bookForm.preShopName
      // }

      let petArr = []
      this.checkList.map(item => {
        let obj = {}
        for(let i=0; i<this.petList.length; i++) {
          if(item == this.petList[i].id) {
            obj.petId = this.petList[i].id
            obj.weight = this.petList[i].weight
          }
        }
        petArr.push(obj)
      })

      Drawer.open({
        title: _title,
        component: EditPaymentDialog,
        data: {
          userForm: this.userInfo,
          // userId: this.userInfo.id,
          preBookId: this.bookForm.id,
          idx: idx,
          payDetailForm: payDetailForm,
          // checkList: this.bookForm.petIdList,
          preBookPetList: petArr,
          petList: this.petList,
          shopId: this.bookForm.preShopId,
          shopName: this.bookForm.preShopName,
          width: 1000,
          proContent: this.bookForm.projectAll?this.bookForm.projectAll.content:'',
          totalMoney: this.bookForm.projectAll?this.bookForm.projectAll.totalMoney:0
        },
        confirm: (result) => {
          this.$emit('confirm')
        }
      })
    },

    addProject(idx) {
      // getFormData(getUserInfo, {id: this.userInfo.id}).then((data)=>{
      //   this.userInfo.userWallet = data.data.userWallet
      //
      // })
      if(this.bookForm.state == -1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前预约单未确认，无法操作',
          type: 'warning'
        });
        return false
      }
      let proDetailForm = {};
      let _title = '';
      if(idx > -1) {
        _title = '编辑消费项目'
        proDetailForm = this.bookForm.projectAll
      } else {
        _title = '添加消费项目'
      }
      // if(idx == -1) {
      //   _title = '添加消费项目'
      //   proDetailForm.shopId = this.bookForm.preShopId
      // }else {
      //   _title = '编辑消费项目'
      //   proDetailForm.id = this.bookForm.projectAllId
      //   proDetailForm.shopId = this.bookForm.preShopId
      //   proDetailForm.shopName = this.bookForm.preShopName
      //   proDetailForm.projectOneList = this.bookForm.projectOneRespList
      // }

      let petArr = []
      this.checkList.map(item => {
        let obj = {}
        for(let i=0; i<this.petList.length; i++) {
          if(item == this.petList[i].id) {
            obj.petId = this.petList[i].id
            obj.weight = this.petList[i].weight
          }
        }
        petArr.push(obj)
      })

      Drawer.open({
        title: _title,
        component: EditProjectDialog,
        data: {
          userForm: this.userInfo,
          // userId: this.userInfo.id,
          preBookId: this.bookForm.id,
          idx: idx,
          proDetailForm: proDetailForm,
          // checkList: this.bookForm.petIdList,
          preBookPetList: petArr,
          petList: this.petList,
          shopId: this.bookForm.preShopId,
          shopName: this.bookForm.preShopName,
          width: 1200
        },
        confirm: (result) => {
          this.$emit('confirm')
        }
      })

    },


    // getPayList(row) {
    //   Dialog.open({
    //     title: '充值记录',
    //     component: payListDialog,
    //     data: {
    //       id: row.id,
    //       userForm: row,
    //       width: '1100px'
    //     },
    //     close: () => {
    //       this.getUserInfo(this.userInfo.id)
    //     }
    //   })
    // },
    //
    // getDeductionList(row) {
    //   Dialog.open({
    //     title: '抵扣记录',
    //     component: DeductionListDialog,
    //     data: {
    //       id: row.id,
    //       userForm: row,
    //       width: '1100px'
    //     },
    //     close: () => {
    //       this.getUserInfo(this.userInfo.id)
    //     }
    //   })
    // },

    getPayDeductionList(row, type) {
      Dialog.open({
        title: '充值抵扣记录',
        component: PayDeductionListDialog,
        data: {
          id: row.id,
          userForm: row,
          width: '1100px',
          type: type
        },
        close: () => {
          this.getUserInfo(this.userInfo.id)
        }
      })
    },

    openRemarkDialog() {
      Dialog.open({
        title: '用户备注',
        component: UserRemarkDialog,
        data: {
          id: this.userInfo.id,
          width: '1100px',
          type: 3,
        },
        close: () => {
          // row['userRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
          // this.getPage()
        }
      })
    },

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        close: () => {
          this.getUserInfo(this.userInfo.id)
        }
      })
    },

    addPet(idx, row) {
      let _title = '';
      let petForm = {}
      _title = '添加宠物'
      Drawer.open({
        title: _title,
        component: AddOrUpdatePet,
        data: {
          petForm: petForm,
          ids: idx,
          userId: this.userInfo.id,
          width: 600
        },
        confirm: (result) => {
          this.getPetInfo(idx, result)
        }
      })
    },

    updatePet(idx, row) {
      // if(!this.editable) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '当前角色没有该门店的编辑权限',
      //     type: 'warning'
      //   });
      //   return false
      // }


      getFormData(getPet, {id: row.id}).then(data => {
        let _title = '';
        let petForm = {}
        _title = '编辑宠物'
        petForm = data.data

        Drawer.open({
          title: _title,
          component: AddOrUpdatePet,
          data: {
            petForm: petForm,
            ids: idx,
            userId: this.userInfo.id,
            width: 600
          },
          confirm: (result) => {
            this.getPetInfo(idx, result)
          }
        })

      })


    },

    getPetInfo(idx, result) {
      getFormData(getPet, {id: result}).then(data => {
        if(idx > -1) {
          this.petList[idx] = data.data
        }else {
          this.petList.push(data.data)
        }
      })
    },

    editPetImg(item) {
      Dialog.open({
        title: '宠物【' + item.name + '】的图片',
        component: PetImgList,
        data: {
          preBookId: this.bookForm.id,
          preShopId: this.bookForm.preShopId,
          petId: item.id,
          width: '800px',
        },
        close: () => {

        }
      })
    },

    getTodayDate() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()+1
      let day = date.getDate()
      return  year + '-' + (month<10?'0' + month:month) + '-' + (day<10?'0' + day:day)
    },

    openDialog() {
      Dialog.open({
        title: '充值记录',
        component: payListDialog,
        data: {
          id: this.userInfo.id,
          userForm: this.userForm,
          width: '1100px'
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getUserInfo(this.userInfo.id)
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    checkPetWeightList(row) {
      Dialog.open({
        title: '【' +row.name + '】的体重记录',
        component: PetWeightDialog,
        data: {
          id: row.id,
          width: '1100px'
        },
        close: () => {
        }
      })
    }


  },
  mounted() {
    console.log('appletOpen：' + this.appletOpen)
    if(this.idx > -1) {
      this.preDay = this.bookForm.preDay
      this.state = this.bookForm.state
      if(this.state == -1) {
        this.confirmState = 1
        this.confirmToast = '该预约单需要客户确认预约后才能修改预约状态'
      }else {
        this.confirmState = 2
        this.confirmToast = '预约单已确认，无法修改预约状态为“待确认”'
      }

      this.bookForm.userInfo.petList.map(pet => {
        pet.weight = ''
      })

      this.bookForm.preBookPetList.map(item => {
        this.checkList.push(item.petId)
        for(let i=0; i<this.bookForm.userInfo.petList.length; i++) {
          if(item.petId == this.bookForm.userInfo.petList[i].id && item.weight > 0) {
            this.bookForm.userInfo.petList[i].weight = item.weight
          }
        }
      })

      this.petList = this.bookForm.userInfo.petList

      if(this.bookForm.projectAll) {
        this.bookForm.projectAll.projectOneList.map(item => {
          item.discountNUm = 0 //会员优惠
          item.extraNUm = 0  //额外优惠
          item.firstDiscountNum = 0  //初步优惠后价格
          item.giveNum = 0  //赠送金额
          item.afterDiscountNum = 0 //总优惠后合计

          if(item.price <= item.discountPrice) {
            item.discountNUm = Number_SubAll(item.originalPrice, item.discountPrice)
            item.extraNUm = Number_SubAll(item.discountPrice, item.price)
            item.firstDiscountNum = Number_SubAll(item.originalPrice, add([item.discountNUm, item.extraNUm]))
          }else {
            item.extraNUm = Number_SubAll(item.originalPrice, item.price)
            item.firstDiscountNum = item.price
          }
          if(this.bookForm.paymentDetail) {
            item.giveNum = ((this.bookForm.paymentDetail.giveDeduction * item.price)/this.bookForm.projectAll.totalMoney).toFixed(2)
            item.afterDiscountNum = Number_SubAll(item.firstDiscountNum, item.giveNum)
          }
        })
      }

    }else {
      // let weekDay = this.weekDayName
      // let date = new Date()
      // let year = date.getFullYear()
      // let idxM = weekDay.indexOf('月')
      // let idxD = weekDay.indexOf('日')
      // let month = weekDay.substring(0, idxM)
      // let day = weekDay.substring(idxM + 1, idxD)
      // let preDate = year + '-' + (month<10?'0' + month:month) + '-' + (day<10?'0' + day:day)
      this.preDay = this.dateTime
      if(this.appletOpen) {
        this.state = -1
        this.confirmState = 1
        this.confirmToast = '该预约单需要客户确认预约后才能修改预约状态'
        let dateN = new Date(this.getTodayDate() + ' ' + '00:00:00')
        console.log(dateN)

        let dateP = new Date(this.preDay + ' ' + '00:00:00')
        console.log(dateP)
        if(dateP < dateN) {
          this.state = 0
          this.confirmState = 2
          this.confirmToast = '该预约单的预约日期小于当天，无需客户确认预约'
        }
      }
    }



  }
}
</script>

<style scoped>

.userName {
  color: #409eff;
  cursor: pointer;
}

.userName:hover {
  text-decoration-line: underline;
}

.pet-list-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pre-tip {
  color: #aaaaaa;
  font-size: 13px;
  display: block;
}

</style>
